import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: "upsale",
  class: "highlights upsale fill mb-4 text-left"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = {
  class: "mb-5 p-4 innerBox text-left",
  key: "overview-details"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex receiptDetailsHeader" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "grow" }, [
    /*#__PURE__*/_createElementVNode("span", { textContent: 'Forsikring' })
  ]),
  /*#__PURE__*/_createElementVNode("div", { textContent: 'Pris/år' })
], -1)
const _hoisted_6 = { class: "flex receiptDetails" }
const _hoisted_7 = { class: "grow details" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "receiptDetails mt-3 flex"
}
const _hoisted_11 = { class: "grow" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 1,
  class: "tile-container tile-wrapper upsaleTile"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TileBlock = _resolveComponent("TileBlock")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.init && _ctx.upSaleProducts?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            innerHTML: _ctx.suggestText()
          }, null, 8, _hoisted_2),
          (_ctx.showExistingProducts && _ctx.cms.showUpsaleDetailBlock)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(['show-hide-details mb-3 text-left', { open: _ctx.showOrderDetails }]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleOrderDetails && _ctx.toggleOrderDetails(...args))),
                textContent: _toDisplayString(_ctx.showOrderDetails ? _ctx.cms.toggleTitleOpenUpSale : _ctx.cms.toggleTitleClosedUpSale)
              }, null, 10, _hoisted_3))
            : _createCommentVNode("", true),
          _createVNode(_Transition, { name: "slide" }, {
            default: _withCtx(() => [
              (_ctx.showOrderDetails && _ctx.showExistingProducts)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upSaleProducts, (product) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: product.productName
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", {
                              class: "productHighlightText",
                              innerHTML: _ctx.getProductHighlights(product)
                            }, null, 8, _hoisted_8)
                          ]),
                          _createElementVNode("div", {
                            class: "productHighlightAmount",
                            innerHTML: _ctx.getProductHighlightsAmount(product)
                          }, null, 8, _hoisted_9)
                        ])
                      ]))
                    }), 128)),
                    (_ctx.getProductHighlightsSummed())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", {
                              innerHTML: _ctx.cms.productTotalAmountTxtUpSale
                            }, null, 8, _hoisted_12)
                          ]),
                          _createElementVNode("div", {
                            innerHTML: _ctx.getProductHighlightsSummed()
                          }, null, 8, _hoisted_13)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.init && _ctx.upSaleProducts?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tileBlocks, (tile) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tile.selectId,
              class: _normalizeClass(['ContentAreaItem', tile.containerClass])
            }, [
              _createVNode(_component_TileBlock, {
                model: tile,
                class: _normalizeClass([{ current: tile.disabled }])
              }, null, 8, ["model", "class"])
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}